import { Button, type ButtonProps } from "@/components/ui/button"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

/** Icon-only ghost button whose label is a tooltip (and the aria-label) —
 *  the editors' toolbar idiom: undo/redo, move, remove, alignment. */
export function TipIconButton({
  label,
  active,
  className,
  children,
  ...props
}: Omit<ButtonProps, "size" | "variant"> & {
  label: string
  active?: boolean
}) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            aria-label={label}
            className={cn(
              "h-7 w-7 text-grey5 hover:text-white",
              active && "bg-white/10 text-white",
              className,
            )}
            {...props}
          >
            {children}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
